export { default } from "./ConnectedApps";
